import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import aovivoBar from '../components/aovivoBar/reducers';
import app from '../components/app/reducers';
import artists from '../components/artists/reducers';
import contact from '../components/contact/reducers';
import poll from '../components/poll/reducers';
import top10 from '../components/top10/reducers';
import top100 from '../components/top100/reducers';
import programs from '../components/programs/reducers';
import news from '../components/news/reducers';
import promotions from '../components/promotions/reducers';
import { createBreakpointReducer } from '../helpers/redux-breakpoint-ssr';
import createClientInfoReducer from '../helpers/clientInfoReducer';
import profile from '../components/profile/reducers';
import videos from '../components/videos/reducers';
import aovivo from '../components/aovivo/reducers';
import podcasts from '../components/podcast/reducers';
import recomende from '../components/recomende/reducers';
import cacaAoTesouro from '../components/cacaAoTesouro/reducers';
import cacaAoTesouroGlobalCheck from '../components/cacaAoTesouroGlobalCheck/reducers';
import workWithUs from '../components/workWithUs/reducers';
import search from '../components/search/reducers';
import daysSentence from '../components/daysSentence/reducers';
import journalists from '../components/journalists/reducers';
import musics from '../components/musics/reducers';
import playlist from '../common/Playlist/reducers';
import freeStreaming from '../components/freeStreaming/reducers';
import affiliates from '../components/affiliates/reducers';
import proPage from '../components/pro/reducers';
import partners from '../components/partners/reducers';
import clients from '../components/clients/reducers';
import spot from '../components/spot/reducers';

// @TODO: clean the reducers! (like, join all the user specific stuff in one root reducer)
// @TODO: put the reducer in an order that makes sense, or maybe order them alphabetically

export default function createRootReducer(headerInfo) {
    return combineReducers({
        clientInfo: createClientInfoReducer(headerInfo),
        aovivoBar,
        aovivo,
        app,
        artists,
        daysSentence,
        contact,
        poll,
        podcasts,
        programs,
        top10,
        top100,
        news,
        promotions,
        profile,
        recomende,
        cacaAoTesouro,
        cacaAoTesouroGlobalCheck,
        search,
        workWithUs,
        breakpointReducer: createBreakpointReducer(headerInfo),
        videos,
        loadingBar: loadingBarReducer,
        journalists,
        musics,
        playlist,
        freeStreaming,
        affiliates,
        proPage,
        partners,
        clients,
        spot,
    });
}
